import { FarmCatalogueTab } from "System/UI/Menu/FarmCatalogueTab";

export const FarmCatalogueTabOrder: Record<FarmCatalogueTab, number> = {
  [FarmCatalogueTab.FLOWERS]: 0,
  [FarmCatalogueTab.TREES]: 1,
  [FarmCatalogueTab.FENCES]: 2,
  [FarmCatalogueTab.HAMMERS]: 3,
  [FarmCatalogueTab.WHEELBARROWS]: 4,
  [FarmCatalogueTab.HOUSE]: 5,
  [FarmCatalogueTab.CROWNS]: 6
};
